import { render } from "./SystemRole.vue?vue&type=template&id=57af653f&scoped=true"
import script from "./SystemRole.vue?vue&type=script&lang=js"
export * from "./SystemRole.vue?vue&type=script&lang=js"

import "./SystemRole.vue?vue&type=style&index=0&id=57af653f&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57af653f"]])

export default __exports__